module.exports = __webpack_public_path__ + "img/pic_collect_empty@2x.03905eea.png";